import { FC, useEffect, useRef } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { ColorOptions } from '../../theme/UiThemeProvider'
import { convertHexToRGBA } from '../../utils/utils'
import { Box, BoxProps } from '../Box'
import { Icon } from '../Icon'
import { TextInput } from '../TextInput'

export interface SearchBarProps {
  onChange: (text: string) => void
  placeholder?: string
  value?: string
  hide?: boolean
  autoFocus?: boolean
  theme?: any
  fontFamily?: string
}

const shadow = {
  shadowColor: 'BLACK',
  shadowOffset: {
    width: 0,
    height: 0.5,
  },
  shadowOpacity: 0.1,
  shadowRadius: 3,
  elevation: 2,
}

const styles = {
  container: (theme: any) =>
    ({
      ...shadow,
      flexDirection: 'row',
      paddingHorizontal: 24,
      borderWidth: 1,
      borderColor: theme ? (theme?.brandColor as ColorOptions) : 'GREY_SEPARATOR',
      alignItems: 'center',
      height: 48,
      width: '100%',
      borderRadius: 30,
      backgroundColor: theme ? (theme?.bodyBgColor as ColorOptions) : 'WHITE',
      underlayColor: theme ? (theme?.bodyBgColor as ColorOptions) : 'WHITE',
    }) as BoxProps,
}

export const SearchBar: FC<SearchBarProps> = (props) => {
  const { placeholder = 'Search', value, hide, autoFocus, theme, fontFamily } = props
  const textInputRef = useRef<RNTextInput>(null)
  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        if (textInputRef.current) {
          textInputRef.current.focus()
        }
      }, 100)
    }
  }, [autoFocus])

  if (hide) {
    return null
  }

  const handleChange = (text: string) => {
    props.onChange(text)
  }
  const leftComponent = (
    <Icon
      id="SEARCH"
      size={20}
      color={theme ? (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions) : 'LIGHT_GREY'}
    />
  )
  const containerOnPress = () => {
    if (textInputRef.current) {
      textInputRef.current.focus()
    }
  }

  return (
    <Box {...styles.container(theme)} onPress={containerOnPress} testID="searchBarBox">
      <TextInput
        showBottomLine={false}
        leftComponent={leftComponent}
        placeholder={placeholder}
        type="h2"
        onChangeText={handleChange}
        autoCorrect={false}
        autoCompleteType="name"
        autoCapitalize="none"
        value={value}
        innerRef={textInputRef}
        color={theme?.bodyTextColor as ColorOptions}
        placeholderTextColor={theme ? (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions) : 'LIGHT_GREY'}
        fontFamily={fontFamily}
        testID="search-bar"
      />
    </Box>
  )
}
